module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/message-alert/message-alert-style2/message-alert-style2.component.scss
// module id = ./src/app/features/message-alert/message-alert-style2/message-alert-style2.component.scss
// module chunks = main